module.exports = __webpack_public_path__ + "static/media/love_only.440b07a0.mp4";